(() => {
  const configElement = document.getElementById('ponik-international-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const preferenceKey = 'poudreuce:language-choice:v1';
  const sessionKey = 'poudreuce:location-resolved:v1';
  const dachStartKey = 'poudreuce:dach-start-resolved:v1';
  const dachCountries = ['DE', 'AT', 'CH'];
  const read = (storage, key) => {
    try { return JSON.parse(storage.getItem(key)); } catch { return null; }
  };
  const save = (storage, key, value) => {
    try { storage.setItem(key, JSON.stringify(value)); } catch { /* Storage may be disabled. */ }
  };
  const defaultLanguage = country => (config.countries[country] || ['en'])[0];
  const setLanguage = (form, language) => {
    let input = form.querySelector('input[name="language_code"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'language_code';
      form.append(input);
    }
    input.value = language;
  };

  // Keep the customer's explicit choice and update language with a country selection.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-ponik-localization]')) return;
    const button = event.submitter;
    if (!button) return;
    let country = config.country;
    let language = config.language;
    if (button.name === 'country_code') {
      country = button.value;
      language = defaultLanguage(country);
      if (!config.languages.includes(language)) language = 'en';
      setLanguage(form, language);
    } else if (button.name === 'language_code' || button.name === 'locale_code') {
      language = button.value;
    } else return;
    save(localStorage, preferenceKey, { country, language });
    save(sessionStorage, sessionKey, true);
  }, true);

  async function localizeFirstVisit() {
    if (config.designMode) return;
    let preference = read(localStorage, preferenceKey);
    const sessionResolved = read(sessionStorage, sessionKey);
    const englishHome = config.language === 'en' &&
      location.pathname.replace(/\/$/, '') === config.root.replace(/\/$/, '');
    const checkDachStart = englishHome && !preference && !read(sessionStorage, dachStartKey);
    if (sessionResolved && !checkDachStart) return;
    // A language-specific link is an intentional destination, including search results.
    if (config.root !== '/' && !checkDachStart) {
      save(sessionStorage, sessionKey, true);
      return;
    }
    if (!preference) {
      let country = config.country;
      try {
        const url = new URL('browsing_context_suggestions.json', location.origin + config.root);
        url.searchParams.set('country[enabled]', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        let response;
        try { response = await fetch(url, { credentials: 'same-origin', signal: controller.signal }); }
        finally { clearTimeout(timeout); }
        if (!response.ok) throw new Error('Localization unavailable');
        const result = await response.json();
        country = result.detected_values?.country?.handle || config.country;
      } catch {
        if (!checkDachStart || !dachCountries.includes(country)) return;
      }
      if (checkDachStart) {
        save(sessionStorage, dachStartKey, true);
        if (!dachCountries.includes(country) && (sessionResolved || config.root !== '/')) return;
      }
      preference = { country, language: defaultLanguage(country) };
    }
    if (!config.languages.includes(preference.language)) preference.language = 'en';
    if (!config.availableCountries.includes(preference.country)) preference.country = config.country;
    save(sessionStorage, sessionKey, true);
    if (preference.country === config.country && preference.language === config.language) return;
    const form = document.getElementById('ponik-auto-localization');
    if (!form) return;
    form.elements.country_code.value = preference.country;
    form.elements.language_code.value = preference.language;
    form.elements.return_to.value = location.pathname + location.search + location.hash;
    form.submit();
  }
  localizeFirstVisit();
})();
